'use server';

import { getPaymentHubFormFields } from '../../../api/requests/paymentHub';
import { actionKitImpFunction } from '../../../components/ozmoit/common';

const getPaymentHubFormFieldsAction = actionKitImpFunction(async () => {
  const response = await getPaymentHubFormFields();
  if (response.error) {
    throw new Error(
      response.error?.data?.message || 'Error registering payment',
    );
  }
  return response.data;
});

export { getPaymentHubFormFieldsAction };
